export type LengthFilterOption = {
  value: string;
  label: string;
};

type LengthPickerPpl = {
  id: string;
  lengthDisplayValue: string;
  isNominal?: boolean | null;
  inventoryOnly?: boolean | null;
};

type LengthFilterLabels = {
  nominal: (length: string) => string;
  actual: (length: string) => string;
};

export function buildLengthFilterOptions(
  platformProductLengths: LengthPickerPpl[] | null | undefined,
  labels: LengthFilterLabels,
  options?: { includeInventoryLengths?: boolean }
): LengthFilterOption[] {
  // Deliberately client-side: platformProductsLengthsForProduct is shared with Add-Inventory and
  // the packing list, which need every length, so it stays unfiltered and the picker hides here.
  // Toggling reveal then needs no refetch. The seller-comparison and CTE paths filter server-side.
  return (platformProductLengths ?? [])
    .filter(
      (ppl) => options?.includeInventoryLengths || ppl.inventoryOnly !== true
    )
    .map((ppl) => ({
      value: ppl.id,
      label: ppl.isNominal
        ? labels.nominal(ppl.lengthDisplayValue)
        : labels.actual(ppl.lengthDisplayValue),
    }));
}
